import { useAxiosClient } from '../';

export const useHomeInfoApi = () => {
    const { axiosClient } = useAxiosClient(true);

    return {
        homeInfo: async (languageId) => (await axiosClient.get(`/v1/homeInfo?languageId=${languageId}`)).data
    }
}